import jsPDF from 'jspdf';
import { format } from 'date-fns';
import 'jspdf-autotable';




const PDFRecievedPurchaseOrderGenerator = (data) => {
  console.log(data);

  const pdf = new jsPDF();
  const userData = localStorage.getItem("UserData");
  let parsedUser;
  parsedUser = JSON.parse(userData);
  // Prepare The Font
  const font = "Newsreader";

  // header Image
  const headerImage = "../../../image/icons/letter.jpg";
  pdf.addImage(headerImage, 'JPG', 10, 10, 190, 43);

  // prepare in here a line
  pdf.setLineWidth(0.1);
  // Line color (RGB)
  pdf.setDrawColor(200, 200, 200);
  pdf.line(10, 55, 200, 55)


  pdf.setFontSize(10);
  pdf.setFont(`${font}`, 'normal');
  pdf.text('Purchase Order Details', 10, 60);
  pdf.text('Invo No: ', 10, 66);
  pdf.text(`${data && data.length > 0 && data[0].genId}`, 25, 66);
  if (data && data.length > 0 && data[0].supplier) {
    pdf.text('Supplier: ', 10, 72);
    pdf.text(data[0].supplier, 27, 72);
  }
  pdf.text(`Date On: ${format(new Date(), 'MMM dd, yyyy')}`, 166, 60);

 // Description
 pdf.setFontSize(11)
 pdf.setFont(`${font}`, 'bold')
 pdf.text('Description:', 10, 85)
 pdf.setFont(`${font}`, 'normal')
 const text = `${data && data.length > 0 && data[0].description}`;
 const Text = text && text !== "" && text?.trim();
 const splitTexts = pdf.splitTextToSize(Text, 185)
 pdf.text(splitTexts, 10, 92);


  pdf.setFontSize(11)
  pdf.setFont(`${font}`, 'bold')
  pdf.text('Dear,', 10, 107)
  pdf.text(`Manager:`, 21, 107)
  const description = `We have received the requested materials from the supplier ${data && data.length > 0 && data[0].supplier},  on ${format(new Date(`${data && data.length > 0 && data[0].updated}`), 'MMM dd, yyyy')} as listed below.`;
  const longText = description && description !== "" && description?.trim();
  pdf.setFont(`${font}`, 'normal')
  pdf.setLineCap(1)
  const splitText = pdf.splitTextToSize(longText, 185)
  pdf.text(splitText, 10, 112);


  // Set document properties
  pdf.setProperties({
    title: "Purchase Order Quotation"
  })


  // Generate AutoTable for item details
  const itemDetailsRows = data?.map((item, index) => [
    (index + 1).toString(),
    item.name.toString(),
    item.requestedQty.toString(),
    item.recievedQty.toString(),
    item.unit.toString(),
    item.isArrived.toString(),
    `$${(+item.amount || 0).toFixed(2)}`,
    `$${(Math.round((item.total || 0) * 100) / 100).toString()}`
  ]);

  const totalSum = data && data.length > 0 && data.reduce((acc, item) => acc + (item.total || 0), 0);

// Format the sum as currency (e.g., $123.45)
const formattedTotal = `$${totalSum.toFixed(2)}`;

  itemDetailsRows.push([
    '',
    '',
    '',
    '',
    '',
    '',
    'Total:',
    formattedTotal
  ]);

  const itemDetailsHeaders = ['S.No', 'Item Name', 'Requested', 'Recieved', 'Units','Status', 'Price', 'Total'];
  const columnWidths = [15, 40, 22, 22, 20, 25, 20,26];

  const headerStyles = {
    fillColor: [240, 240, 240],
    textColor: [0],
    fontFamily: 'Newsreader',
    fontStyle: 'bold',
  };

  pdf.setFont('Newsreader');
  const itemDetailsYStart = 120;
  pdf.autoTable({
    head: [itemDetailsHeaders],
    body: itemDetailsRows,
    startY: itemDetailsYStart,
    headStyles: {
      fillColor: headerStyles.fillColor,
      textColor: headerStyles.textColor,
      fontStyle: headerStyles.fontStyle,
      fontSize: 10,
      font: 'Newsreader',
      halign: 'left',
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0] }, 
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
      4: { cellWidth: columnWidths[4] },
      5: { cellWidth: columnWidths[5] },
      6: { cellWidth: columnWidths[6] },
      7: { cellWidth: columnWidths[7] },
    },
    
    alternateRowStyles: { fillColor: [255, 255, 255] },
    bodyStyles: {
      fontSize: 10,
      font: 'Newsreader',
      cellPadding: { top: 1, right: 5, bottom: 1, left: 2 },
      textColor: [0, 0, 0],
      rowPageBreak: 'avoid',
    },
    margin: { top: 10, left: 10 },
  });

  


  // Add summary and page numbers
  const summaryYStart = pdf.internal.pageSize.getHeight() - 50;

  pdf.setFont('Newsreader', 'noraml')
  pdf.text('Signatured, _________________', 13, summaryYStart + 8)
  pdf.text('Thanking You,', 13, summaryYStart + 18)
  pdf.text('Yours Faithfully,', 13, summaryYStart + 23)
  pdf.text('For ', 13, summaryYStart + 28)
  pdf.setFont('Newsreader', 'bold')
  pdf.text('The Palms Hotel', 19, summaryYStart + 28)

  const totalPages = pdf.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    pdf.setFontSize(10);
    pdf.setFont('Newsreader', 'normal');
    pdf.text(`Page ${i} of ${totalPages}`, pdf.internal.pageSize.width - 10, pdf.internal.pageSize.height - 8, { align: 'right' });
    
    pdf.line(10, 283, 200, 283)
    pdf.setFont(`${font}`, "italic")
    pdf.text(`Prepared By:${parsedUser?.name}`, 10, pdf.internal.pageSize.height - 8)
  }
  
  // pdf.line(10, 283, 200, 283)
  // pdf.setTextColor(...ColorConverter('#099396'))
  // pdf.setFont(`${font}`, "italic")
  // pdf.text(`Prepared By:${parsedUser?.name}`, 10, 290)

  return pdf.save('PurchaseOrderDetail.pdf');

}

export default PDFRecievedPurchaseOrderGenerator;
























